import { combineReducers } from 'redux';
import { reducer as reduxForm } from 'redux-form';
import userReducer from './userReducer';
import continuerefReducer from './continuerefReducer';
import paymentsReducer from './paymentsReducer';
import screensReducer from './screensReducer';
import projectsReducer from './projectsReducer';
import charitiesReducer from './charitiesReducer';
import filtersReducer from './filtersReducer';
import favouritesReducer from './favouritesReducer';

export default combineReducers({
    user: userReducer,
    continueref: continuerefReducer,
    payments: paymentsReducer,
    screens: screensReducer,
    projects: projectsReducer,
    charities: charitiesReducer,
    filters: filtersReducer,
    favourites: favouritesReducer,
    form: reduxForm
});



// WEBPACK FOOTER //
// ./src/reducers/index.js